// extracted by mini-css-extract-plugin
export default {"layout":"layout___P2n3r","duplicateMemoryEstimates":"duplicateMemoryEstimates___CskyM","even":"even___i7Ke1"};